import { useRemoteClientGet } from '@/configs/http-client'
import { Endpoints } from '@/remote/endpoints'
import { usePromiseToast } from '@/view/hooks/toast-promisse'
import { convertDateDisplayFormat } from '@/view/utils/formatDateDisplay'
import { Student } from '@/view/validators/member-schema-validator'
import { Phone } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { CardInfoSelectMember } from '../../components/card-info-select-member'
import { Avatar, AvatarFallback } from '../../components/ui/avatar'
import { Badge } from '../../components/ui/badge'
import { Card } from '../../components/ui/card'
import { Button } from '../../components/ui/components'
import { Textarea } from '../../components/ui/textarea'
//import { useNavigateRoute } from '../../hooks'
import { CreditCardModal } from '../../components/credit-cart-show'
import { convertParamsToJson, useCashfitParams } from '../../hooks/use-params'

type OverviewTabProps = {
  id: string
}
export default function OverviewTab({ id }: OverviewTabProps) {
  //const { navigateTo } = useNavigateRoute()
  const [memberInfo, setMemberInfo] = useState<Student>()
  const { remoteClientGet } = useRemoteClientGet()
  const { triggerToast } = usePromiseToast()
  //const [loading, setLoading] = useState(true)
  const fetchMemberInfo = async () => {
    try {
      const response = await remoteClientGet(Endpoints.students + '/' + id)
      const data = response?.data?.data ?? {}
      // setLoading(false)
      setMemberInfo(data)
    } catch (error) {
      //setLoading(true)
      console.error(error)
    }
  }

  const generateWhatsAppLink = (phoneNumber: string, message: string): string => {
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  useEffect(() => {
    if (id) {
      triggerToast(fetchMemberInfo(), {
        loading: 'Carregando dados...',
        success: 'Dados carregados',
        error: 'Erro ao carregar dados.'
      })
    }
  }, [id])

  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))
  const backToStudents = () => setParams({ tabSelected: 'studants' as any })
  if (!params.get('tabContentId')) return <CardInfoSelectMember backToStudents={backToStudents} />

  return (
    <Card className="w-full mx-auto p-6">
      <div className="grid gap-6 md:grid-cols-[auto,1fr]">
        <div className="flex flex-col items-center gap-4">
          <Avatar className="w-32 h-32">
            <AvatarFallback className="text-4xl">{memberInfo?.nome[0]}</AvatarFallback>
          </Avatar>
          {!memberInfo?.status && (
            <Badge variant="destructive" className="uppercase">
              Cancelado
            </Badge>
          )}
          {/* {!memberInfo.usesApp && (
              <Badge variant="secondary" className="text-xs">
                Cliente não utiliza aplicativo
              </Badge>
            )} */}
        </div>

        <div className="space-y-6">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <h1 className="text-2xl font-bold flex items-center gap-2">{`${memberInfo?.id || 0} - ${memberInfo?.nome || 'Sem Aluno selecionado'}`}</h1>
              <div className="text-sm text-muted-foreground mt-1">Cliente desde: {convertDateDisplayFormat(memberInfo?.inclusao.split('T')[0] || '') || 'Sem Aluno selecionado'}</div>
            </div>
          </div>

          <div className="grid gap-4">
            <div>
              <h2 className="text-sm font-semibold mb-2">TIPO</h2>
              <div className="flex gap-2">
                <Badge variant="outline">Celular</Badge>
              </div>
            </div>

            <div>
              <h2 className="text-sm font-semibold mb-2">CONTATO</h2>
              <div className="flex items-center gap-4">
                <span className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  {`${memberInfo?.telefone[0]?.ddd || ''} -${memberInfo?.telefone[0]?.numero || ''}`}
                </span>
                {/* <Button variant="outline" size="sm" className="gap-2">
                  <MessageSquare className="w-4 h-4" />
                  SMS
                </Button> */}
                  <a href={generateWhatsAppLink(`${memberInfo?.telefone[0]?.ddd}${memberInfo?.telefone[0]?.numero}`, 'Olá, estou entrando em contato com você através do WhatsApp!')}>
                  <Button variant="outline" size="sm" className="gap-2 text-green-600">
                    Whatsapp
                  </Button>
                </a>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              {/* <Badge variant="outline" onClick={() => navigateTo(('/dashboard/temp?memberId=' + id) as any)} className="cursor-pointer">
                Ficha de Exercícios
              </Badge> */}
              {/* <Badge variant="outline">Avaliação Física</Badge>
              <Badge variant="outline">Gympass</Badge>
              <Badge variant="outline">TotalPass</Badge> */}
            </div>

            <div>
              <h2 className="text-sm font-semibold mb-2">OBSERVAÇÃO</h2>
              <Textarea placeholder="Adicione a observação..." className="resize-none" />
            </div>

            <div className="text-sm text-muted-foreground">
              <div>{`Consultor: ${memberInfo?.consultor?.nome || ''}`}</div>
              <div>Professor: { }</div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-2 mt-6">
        {/* <Button variant="secondary">Clube Fit</Button>
        <Button variant="destructive">Restringir Acesso</Button>
        <Button variant="secondary">Anexos</Button> */}
        <CreditCardModal userId={id} />
      </div>
    </Card>
  )
}
